import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { Key } from "ts-key-enum";
import { defaultState } from "tsi-common-react/src/apps/reviews/defaults";
import { useAppSelector } from "tsi-common-react/src/store/reducers";

type IProps = Immutable<{
    isLoading: boolean;
}> & {
    onLoadMore: () => void;
};

const LoadMoreButton = (props: IProps): React.ReactNode => {
    const hasMore = useAppSelector((rootState) => {
        const state = rootState.reviews || defaultState;
        return state.ui.hasMore;
    });

    const onKeyPressHandler = (event: React.KeyboardEvent) => {
        if (!props.onLoadMore) {
            return null;
        }
        if (event.key === Key.Enter) {
            props.onLoadMore();
        }
        return null;
    };

    if (!hasMore) {
        return null;
    }

    const loadMoreClasses = classNames({
        "load-more": true,
        "al-reviews__load-more": true,
        "loading": props.isLoading,
        "last-page": !hasMore,
    });

    return (
        <button
            className={loadMoreClasses}
            onClick={props.onLoadMore}
            onKeyPress={onKeyPressHandler}
        >
            {/* TODO(i18n): Use t tagged template: {t`LOAD MORE REVIEWS`} */}
            LOAD MORE REVIEWS
        </button>
    );
};

export { LoadMoreButton };
